import { Link, Stack } from '@rbilabs/universal-components';

export const AnchorLinks = Stack.withConfig({
  flexWrap: {
    base: 'nowrap',
    md: 'wrap',
  },
  alignItems: 'center',
  direction: { base: 'column', md: 'row' },
  justifyContent: 'center',
  space: '$4',
  width: {
    base: '90%',
    md: '100%',
  },
  margin: 'auto',
  paddingY: '$5',
  paddingX: {
    md: '$24',
  },
  borderTopWidth: '2',
  borderBottomWidth: '2',
  borderColor: Styles.color.grey.five,
});

export const AnchorLinkItem = Link.withConfig({
  isUnderlined: false,
  padding: { base: '$0', md: '$1' },
});
